<template>
  <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
    <v-card v-if="visible" :class="[$vuetify.breakpoint.smAndDown ? 'no-transition' : '']"
            class="mini-modal border layout column justify-center modal-auto"
    >
      <span class="close-modal">
        <v-btn v-if="hideClose" color="error" @click.native.stop="closeModal(true, true)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </span>

      <div class="mini-modal-content maximized-content maximized-child-content scroll-y">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
          <component :is="modalComponent" ref="modalComponent" :class="[$vuetify.breakpoint.smAndDown ? 'no-transition' : '']" v-bind="componentProps" name="content" />
        </transition>
      </div>
    </v-card>
  </transition>
</template>

<script>
import { EventBus } from '../store/EventBus.js'

export default {
  name: 'MiniModal',
  props: {
    hideClose: {
      type: Boolean,
      default: true
    },
    classes: {
      type: String,
      default: 'mini-modal'
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      modalComponent: null,
      componentProps: ''
    }
  },
  computed: {
    maximized () {
      return this.$vuetify.breakpoint.xsOnly
    }
  },
  watch: {
    maximized: function (value) {
      if (this.visible) {
        if (value) { this.$router.push({ query: { back: true } }) } else if (this.$router.history.current.query.back) { this.$router.go(-1) }
      }
    }
  },
  created () {
    EventBus.$on('closeModal', (destroy) => this.closeModal(destroy, true))
  },
  beforeDestroy () {
    EventBus.$off('closeModal')
  },
  methods: {
    show (component, props) {
      this.closeModal(true, false)
      document.documentElement.className += ' maximized-modal'
      this.$nextTick(() => {
        this.modalComponent = component
        this.componentProps = props
        this.visible = true
        if (this.maximized) this.$router.push({ query: { back: true } })
      })
    },
    closeModal (destroy, back) {
      if (destroy) {
        this.modalComponent = null
        this.componentProps = null
      }
      this.visible = false
      document.documentElement.className = document.documentElement.className.replace('maximized-modal', '')
      if (back && this.maximized && this.$router.history.current.query.back) {
        this.$router.go(-1)
      }
    }
  }

}
</script>

<style>
.no-transition {
  transition: none !important;
  animation: none !important;
}
</style>
